module.exports = __webpack_public_path__ + "img/6.1eb444e1.png";